import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  TextField,
} from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { todayIso } from "../../../shared/timeline";

const button = { textTransform: "none", fontWeight: 600 } as const;

/**
 * Asks for the day an offer was accepted: empty until the user enters it or
 * clicks Today, and no later than today. Closes with the day, or with
 * nothing where the user cancels.
 */
export const AcceptOfferDialog = ({
  onClose,
}: {
  onClose: (acceptedOn?: string) => void;
}) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: "case.analytics.settlement.acceptDialog",
  });
  const today = todayIso();
  const [acceptedOn, setAcceptedOn] = useState("");
  const valid = acceptedOn !== "" && acceptedOn <= today;

  return (
    <Dialog open onClose={() => onClose()}>
      <DialogTitle>{t("title")}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>{t("description")}</DialogContentText>
        <Stack direction="row" spacing={1.5} sx={{ alignItems: "center" }}>
          <TextField
            type="date"
            size="small"
            required
            label={t("acceptedOn")}
            value={acceptedOn}
            onChange={(event) => setAcceptedOn(event.target.value)}
            error={acceptedOn !== "" && !valid}
            helperText={acceptedOn !== "" && !valid ? t("future") : undefined}
            slotProps={{
              inputLabel: { shrink: true },
              htmlInput: { max: today },
            }}
            sx={{ width: 220 }}
          />
          <Button
            variant="outlined"
            sx={button}
            onClick={() => setAcceptedOn(today)}
          >
            {t("today")}
          </Button>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button sx={button} onClick={() => onClose()}>
          {t("cancel")}
        </Button>
        <Button
          variant="contained"
          sx={button}
          disabled={!valid}
          onClick={() => onClose(acceptedOn)}
        >
          {t("accept")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
